import { GTPartnerDocumentCategoryInput } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const documentsMessages = defineMessages({
  [GTPartnerDocumentCategoryInput.OfficialId]: {
    id: 'partners.form.officialId.label',
    defaultMessage: 'Official ID'
  },
  [GTPartnerDocumentCategoryInput.ProofOfAddress]: {
    id: 'partners.form.proofOfAddress.label',
    defaultMessage: 'Proof of Address'
  },
  [GTPartnerDocumentCategoryInput.ConstitutiveAct]: {
    id: 'partners.form.constitutiveAct.label',
    defaultMessage: 'Constitutive Act'
  },
  [GTPartnerDocumentCategoryInput.PowerOfAttorney]: {
    id: 'partners.form.powerOfAttorney.label',
    defaultMessage: 'Power of Attorney'
  },
  [GTPartnerDocumentCategoryInput.AccountStatementCover]: {
    id: 'partners.form.accountStatementCover.label',
    defaultMessage: 'Account Statement Cover'
  },
  [GTPartnerDocumentCategoryInput.ComplianceOpinion]: {
    id: 'partners.form.complianceOpinion.label',
    defaultMessage: 'Compliance Opinion'
  }
})
